module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qcirc24-07ce7adea5f7732385b675b8f33cd96f.jpg";